<script>
import AppButton from '@/components/ui/AppButton.vue'
import Icons from '@/components/Icons.vue'

export default {
	name: 'ProfileIdentityCard',
	components: {
		AppButton,
		Icons
	},
	data() {
		return {
			avatarLoadFailed: false
		}
	},
	props: {
		avatarUrl: {
			type: String,
			default: null
		},
		fullName: {
			type: String,
			default: ''
		},
		memberCode: {
			type: [String, Number],
			default: ''
		},
		photoEnabled: {
			type: Boolean,
			default: false
		}
	},
	emits: ['change-photo'],
	computed: {
		showAvatar() {
			return Boolean(this.avatarUrl) && !this.avatarLoadFailed
		}
	},
	watch: {
		avatarUrl() {
			this.avatarLoadFailed = false
		}
	},
	methods: {
		handleAvatarError() {
			this.avatarLoadFailed = true
		}
	}
}
</script>

<template>
	<article class="profile-info-card profile-identity-card" data-qa="profile-identity-card">
		<div class="profile-identity-card__avatar">
			<img
				v-if="showAvatar"
				class="profile-identity-card__image"
				data-qa="profile-identity-avatar-image"
				:src="avatarUrl"
				:alt="$t('myArea.headerInfo.avatarAlt', { name: fullName })"
				@error="handleAvatarError"
			>
			<Icons v-else class="profile-identity-card__fallback" name="profilePhotoPlaceholder" aria-hidden="true" />
			<AppButton
				v-if="photoEnabled"
				class="profile-identity-card__camera"
				data-qa="profile-identity-photo-button"
				variant="profile-camera"
				icon="profileCamera"
				:aria-label="$t('buttons.changePhoto')"
				:title="$t('buttons.changePhoto')"
				@click="$emit('change-photo')"
			/>
		</div>

		<div class="profile-identity-card__content">
			<h2 data-qa="profile-identity-name-title">{{ fullName || $t('myArea.headerInfo.nameFallback') }}</h2>
			<p v-if="memberCode" data-qa="profile-identity-member-id-text">{{ $t('myArea.headerInfo.memberId', { id: memberCode }) }}</p>
		</div>
	</article>
</template>

<style lang="sass" scoped>
@use '../../assets/sass/utilities/_responsive' as *

.profile-identity-card
	display: flex
	align-items: center
	gap: 1.5rem

	&__avatar
		position: relative
		flex: 0 0 4.5rem
		width: 4.5rem
		height: 4.5rem

	&__image, &__fallback
		display: block
		width: 100%
		height: 100%
		border: 1px solid var(--lg-light-gray-300)
		border-radius: 50%

	&__image
		object-fit: cover

	&__fallback
		color: var(--lg-mid-gray-200)

	&__camera
		position: absolute
		right: -0.125rem
		bottom: -0.125rem

	&__content
		min-width: 0

		h2
			margin: 0
			overflow: hidden
			font-family: var(--lgei-headline)
			font-size: 1.5rem
			font-weight: 400
			line-height: 1
			text-overflow: ellipsis
			white-space: nowrap
			color: var(--club--title-default)

		p
			width: fit-content
			max-width: 100%
			margin: 0.5rem 0 0
			padding: 0.25rem 0.5rem
			overflow: hidden
			border-radius: 0.375rem
			font-family: var(--lgei-headline)
			font-size: 0.75rem
			font-weight: 600
			line-height: 1
			text-overflow: ellipsis
			white-space: nowrap
			background-color: var(--lg-light-gray-300)
			color: var(--lg-mid-gray-200)
</style>
